import { Injectable } from "@angular/core";
import { EventService } from "../event-service/event.service";

@Injectable()
export class PageVisibilityService {
  constructor(private eventService: EventService) {}

  public setUpListener() {
    document.addEventListener("visibilitychange", () => {
      if (document.hidden) {
        this.eventService.publish("documentHidden");
      } else {
        this.eventService.publish("documentVisible");
      }
    });
  }
}
